<template>
  <div class="pa-4">
    <div>
      <v-card class="bjjlink-card" elevation="0" outlined>
        <v-card-title>{{ $t("message.manage_expense") }}</v-card-title>
        <v-card-text class="pb-0">
          <v-text-field outlined dense maxlength="50" :label="$t('message.name')" v-model="itemName"></v-text-field>
          <v-textarea rows="3" outlined dense :label="$t('message.description')" v-model="itemDescription"></v-textarea>
          <v-row>
            <v-col>
              <v-text-field hide-details outlined dense :rules="[numberRule]" :label="$t('message.amount')"
                v-model="price"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field hide-details outlined dense disabled v-model="currencyText"
                :label="$t('message.currency')"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field hide-details outlined dense :rules="[numberRule]" :label="$t('message.tax_amount')"
                v-model="tax"></v-text-field>
              <div class="text-caption ml-1">{{ $t('message.tax_excluded_explained') }}</div>
            </v-col>
          </v-row>
          <v-text-field v-if="false" style="width:10%" outlined dense
            :rules="[() => !isNaN(quantity) || $t('message.not_a_number')]" :label="$t('message.quantity')"
            v-model="quantity"></v-text-field>
          <span class="error--text" v-if="!validQuantity">
            {{
              $t("message.invalid_quantity")
            }}
          </span>
        </v-card-text>
        <v-card-text>
          <v-combobox :items="availableTags" v-model="tags" :search-input.sync="search" small-chips dense outlined
            :label="$t('message.category')">
            <template slot="no-data">
              <v-list-item>
                <span class="subheading">{{ $t('message.click_enter_add_new') }}:</span>
                <v-chip label small>{{ search }}</v-chip>
              </v-list-item>
            </template>
          </v-combobox>
          <v-textarea rows="3" outlined dense :label="$t('message.notes')" v-model="notes"></v-textarea>
          <DatePicker v-model="itemDate" :past-event="true">
          </DatePicker>
        </v-card-text>
        <v-list-item two-line v-if="buyer" @click="checkMemberAndGo()">
          <v-list-item-avatar size="30" v-if="buyer.userImageSmall">
            <ImageDisplay :src="buyer.userImageSmall" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ buyer.displayName }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('message.beneficiary') }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else-if="transactionId != 'new'">
          <v-list-item-action>
            <v-icon>mdi-account-check-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <v-btn small text @click.stop="assignBuyerDialog = true">
                {{ $t('message.assign') }}
              </v-btn>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t("message.beneficiary") }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <div v-if="checkins && checkins.length > 0">
          <v-list>
            <v-subheader>{{ $t("message.checkins") }}</v-subheader>
            <template v-for="(checkin, index) in checkins">
              <v-list-item :key="checkin._id">
                <v-list-item-action class="mr-4">
                  <v-icon v-if="checkin.source == 'tablet'">mdi-tablet</v-icon>
                  <v-icon v-else-if="checkin.source == 'manual'">mdi-monitor</v-icon>
                  <v-icon v-else>mdi-cellphone
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content class="text-left">
                  <v-list-item-title>
                    <span>
                      {{ $d(new Date(checkin.date), "long", $i18n.locale) }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span v-if="checkin.name && checkin.name != ''">
                      {{ $t("message.class") }} - {{ checkin.name }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index + 1 < checkins.length" :key="'checkins_divider_' + index"></v-divider>
            </template>
          </v-list>
        </div>
      </v-card>
      <v-card class="bjjlink-card" elevation="0" outlined>
        <v-card-actions>
          <v-btn :disabled="uploading" outlined class="elevation-0" @click="filePicker()" color="primary" small dark>
            <v-icon>mdi-receipt-text-outline</v-icon>
            {{ $t("message.upload_receipt") }}
          </v-btn>
          <v-btn v-if="receipt" class="elevation-0" @click="receipt = null;" color="error" small dark>
            <v-icon>mdi-trash-can-outline</v-icon>
            {{ $t("message.delete") }}
          </v-btn>
        </v-card-actions>
        <v-progress-linear v-if="uploading" indeterminate color="secondary"></v-progress-linear>
        <v-card-text v-if="receipt">
          <ImageDisplay :src="receipt" style="max-width: 100%;" />
        </v-card-text>
        <v-card-text>
          <div v-if="uploadingMessage" class="text-center">
            {{ uploadingMessage }}
          </div>
          <input style="display: none" type="file" accept="image/*" @change="onFileSelect" ref="fileUploadInput" />
        </v-card-text>
      </v-card>
      <v-card class="bjjlink-card" elevation="0" outlined>
        <v-card-actions v-allowed="'sell_items'">
          <v-btn outlined :loading="handlingCharges" elevation="0"
            v-if="validQuantity && itemName && transactionId == 'new'" color="primary" @click="addExpense()">
            {{ $t("message.add") }}
          </v-btn>
          <v-btn outlined :loading="handlingCharges" v-else-if="validQuantity && itemName && existing" color="primary"
            elevation="0" small @click="updateExpense()">
            {{ $t("message.update") }}
          </v-btn>
          <v-btn elevation="0" small @click="goBack()">
            {{
              $t("message.back")
            }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="transactionId != 'new'" color="error" elevation="0" @click="deleteExpenseDialog = true;">
            <v-icon>mdi-trash-can-outline</v-icon>
            {{ $t("message.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="deleteExpenseDialog" max-width="90%">
      <v-card class="pa-2">
        <v-card-text>{{ $t('message.delete_item_confirm') }}</v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="error" @click.stop="removeExpense()">{{ $t('message.delete') }}</v-btn>
          <v-btn small elevation="0" @click.stop="deleteExpenseDialog = false">{{ $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignBuyerDialog" width="90%" pa-1>
      <v-card outlined>
        <v-card-title>
          {{ $t("message.assign_buyer") }}
        </v-card-title>
        <v-card-text>
          <members-autocomplete :label="$t('message.member')" v-model="assignMemberId" />
        </v-card-text>
        <v-card-actions>
          <v-btn outlined elevation="0" small color="primary" @click="assignBuyer()">OK</v-btn>
          <v-btn elevation="0" small @click="assignBuyerDialog = false;">
            {{ $t("message.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import MembersAutocomplete from "@/components/inputs/MembersAutocomplete.vue";
import Api2 from "@/services/Api2";
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask,
  },
  data() {
    return {
      loading: true,
      transactionId: this.$route.params.transactionId,
      itemName: null,
      itemDate: new Date(),
      handlingCharges: false,
      itemDescription: null,
      assignBuyerDialog: null,
      assignMemberId: null,
      checkoutInitialized: false,
      validQuantity: true,
      currencyText: null,
      price: null,
      tax: null,
      mask1: "#########",
      tags: null,
      availableTags: [],
      existing: false,
      mask2: "##",
      priceDecimal: "00",
      uploading: false,
      uploadingMessage: null,
      quantity: 1,
      receipt: null,
      checkins: null,
      buyer: null,
      selectedFile: null,
      search: null,
      paymentForm: false,
      deleteExpenseDialog: false,
      uploadedReceipt: null,
      notes: null,
      currency: null,
      numberRule: v => {
        if (v && !v + "".trim()) return true;
        if (v && !isNaN(parseFloat(v)) && v >= 0) return true;
        return this.$t('message.invalid_number');
      },
    };
  },
  components: {
    DatePicker,
    MembersAutocomplete
  },
  created() {
    Api2()
      .getWithCache("admins/academy/" + this.$store.state.selectedAcademy, {}, 60)
      .then((response) => {
        this.currency = response.currency;
        this.currencyText = response.currency
          ? response.currency.toUpperCase()
          : "???";
      });
    this.getAvailableTags();
    if (this.transactionId == 'new') {
      this.quantity = 1;
    } else {
      this.existing = true;
      this.getTransactionData();
    }
  },
  watch: {
    quantity: {
      handler: function (newValue) {
        this.checkAmountValidity(newValue);
      },
    },
  },
  methods: {
    getTransactionData() {
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/payments/transactions/" +
          this.transactionId
        )
        .then((response) => {
          const transaction = response.data.transaction;
          this.checkins = transaction.checkins;
          this.buyer = transaction.buyer;
          this.receipt = transaction.receipt;
          this.notes = transaction.notes;
          if (transaction.tags)
            this.tags = transaction.tags[0];
          if (transaction.items && transaction.items.length == 1) {
            this.itemDescription = transaction.items[0].description;
            this.itemName = transaction.items[0].name;
            this.itemDate = new Date(transaction.completed);
            this.priceDecimal = 0;
            if (transaction.amount < 0) {
              const amount = (transaction.amount * -1).toFixed(2);//Make it positive for now
              this.price = amount;
              this.priceDecimal = amount.substring(
                amount.length - 2,
                amount.length
              );
            } else {
              this.price = 0;
              this.priceDecimal = 0;
            }
            if (transaction.taxAmount > 0)
              this.tax = transaction.taxAmount;
          }
        });
    },
    assignBuyer() {
      this.assignBuyerDialog = false;
      Api2()
        .patch(
          "payments/managedacademy/" +
          this.$store.state.managedAcademy +
          "/transaction/" +
          this.transactionId + "/buyer/" + this.assignMemberId
        )
        .then(() => {
          this.getTransactionData();
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch((e) => {
          console.log(e)
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
    checkMemberAndGo() {
      if (this.buyer) {
        this.goToMember(this.buyer._id, this.buyer.displayName);
      }
    },
    getAvailableTags() {
      Api2()
        .get("payments/academy/" +
          this.$store.state.managedAcademy +
          "/transactions/tags/all")
        .then((response) => {
          const data = response.data;
          if (data) {
            this.availableTags = data.tags
          }
        })
    },
    filePicker() {
      this.$refs.fileUploadInput.click();
    },
    onFileSelect(event) {
      this.uploading = true;
      if (event.target.files[0]) {
        this.receipt = null;
        this.selectedFile = event.target.files[0];
        const size = event.target.files[0].size;
        const sizeMb = Math.floor(size / 1000000);
        if (sizeMb <= 15) {
          this.uploadPhoto();
        } else {
          this.uploading = false;
          this.showAlert(
            "error",
            "Sorry! Your image is too big (" +
            sizeMb +
            "mb), try a smaller one."
          );
        }
      } else {
        this.uploading = false;
      }
    },
    uploadPhoto() {
      const formData = new FormData();
      this.uploadingMessage = this.$t("message.image_upload_progress");
      const d = new Date();
      const millis = d.getTime();
      const imgExtension = this.selectedFile.type.toLowerCase().split('/')[1];
      const blob = new Blob([this.selectedFile], { type: this.selectedFile.type });
      formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.' + imgExtension);
      Api2().post("content/image/admin", formData)
        .then(res => {
          const data = res.data;
          if (data) {
            const vm = this;
            setTimeout(function () {
              vm.receipt = data.original;
              vm.uploadedReceipt = data;
              vm.uploadingMessage = null;
              vm.uploading = false;
            }, 4000);
          }
        })
        .catch(() => {
          this.showAlert("error", "Oops!", ":(");
          this.uploading = false;
        });
    },
    checkAmountValidity(q) {
      if (!isNaN(q) && q != "") {
        this.validQuantity = true;
      } else {
        this.validQuantity = false;
      }
      if (this.validQuantity && this.quantity <= 0) this.validQuantity = false;
    },
    removeExpense() {
      Api2()
        .delete("payments/academy/" +
          this.$store.state.managedAcademy +
          "/expenses/" + this.transactionId)
        .then((response) => {
          const data = response.data;
          if (data) {
            this.goBack();
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    updateExpense() {
      const items = this.setupItems();
      const postData = {
        items: items,
        receipt: this.receipt,
        tax: this.tax,
        processedBy: "desk",
        quantity: this.quantity,
        completed: this.itemDate,
        tags: [this.tags],
        notes: this.notes
      };
      var postUrl =
        "payments/academy/" +
        this.$store.state.managedAcademy +
        "/expenses/" + this.transactionId;
      Api2()
        .patch(postUrl, postData)
        .then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.updated"));
          }
        })
        .catch((e) => {
          this.handlingCharges = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    addExpense() {
      this.handlingCharges = true;
      const items = this.setupItems();
      if (!items) {
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        return;
      }
      const postData = {
        items: items,
        receipt: this.uploadedReceipt ? this.uploadedReceipt.location : null,
        completed: this.itemDate,
        processedBy: "desk",
        tax: this.tax,
        quantity: this.quantity,
        tags: [this.tags]
      };
      let postUrl =
        "payments/academy/" +
        this.$store.state.managedAcademy +
        "/expenses/new";
      Api2()
        .post(postUrl, postData)
        .then((response) => {
          const data = response.data;
          if (data) {
            this.goBack();
          }
        })
        .catch((e) => {
          this.handlingCharges = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    setupItems() {
      if (this.priceDecimal == "") this.priceDecimal = "00";
      else if (this.priceDecimal.length == 1)
        this.priceDecimal = this.priceDecimal + "0";
      const amountDecimal = new Number(this.price);
      if (!amountDecimal || amountDecimal <= 0) return null;
      const items = [
        {
          name: this.itemName,
          description: this.itemDescription,
          amountDecimal: amountDecimal.valueOf(),
          currency: this.currency,
          quantity: this.quantity,
        },
      ];
      return items;
    },
  },
};
</script>

<style scoped></style>
